import { axiosInstance } from '../common/api';

const holidaysEndpoint = "/company-holidays";

// Create a new holiday
export const createHoliday = (data) => {
  const url = `${holidaysEndpoint}/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

// Get all holidays
export const getAllHolidays = () => {
  const url = `${holidaysEndpoint}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

// Update a holiday
export const updateHoliday = (id, data) => {
  const url = `${holidaysEndpoint}/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

// Delete a holiday
export const deleteHoliday = (id) => {
  const url = `${holidaysEndpoint}/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
